import { TFormSelectOption } from "@housebets/housebets-x-package";

export const oddsOptions: TFormSelectOption[] = [
  {
    id: "1",
    name: "Decimals",
  },
  {
    id: "2",
    name: "Float",
  },
];

export const currencyOptions: TFormSelectOption[] = [
  {
    id: "1",
    name: "USD",
    icon: "/img/select/fiat/11.png",
  },
  {
    id: "2",
    name: "EURO",
    icon: "/img/select/fiat/12.png",
  },
];
